import styled from 'styled-components';

import { Modal } from '~sharedComponents/Modal/Modal';
import { Heading2, Body1, Body2 } from '@estee/elc-typography';
import { breakpoint, ContentSpacing } from '@estee/elc-base-theme';

const { space8, space16, space24, space32 } = ContentSpacing;

export const ResponsiveModalWrapper = styled(Modal)`
    padding: ${space24} ${space32} ${space32} ${space32};
`;

export const ReplenishmentModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    padding-top: ${space24};
    gap: ${space24};
`;

export const StyledHeader = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
`;

export const StyledHeading2 = styled(Heading2)`
    text-align: center;
    margin-bottom: ${space8};
`;

export const StyledParagraph = styled(Body1)`
    display: flex;
    text-align: center;
`;

export const StyledParagraphFooter = styled(Body2)`
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    text-align: center;
    a {
        text-decoration: underline;
    }
`;
export const StyledStepsWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: ${space24};
    padding: ${space24} 0;
    ${breakpoint('largeScreen')`{
        flex-direction: row;    
    }`}
    border-top-width: 1px;
    border-top-style: solid;
    border-bottom-width: 1px;
    border-bottom-style: solid;
`;

export const StyledStep = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    flex: 1;
`;

export const StyledStepTitle = styled.div`
    font-size: ${space16};
    font-style: normal;
    font-weight: 600;
    text-transform: uppercase;
    text-align: center;
`;
export const StyledStepDescription = styled.div`
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    text-align: center;
`;

export const StyledIcon = styled.img`
    height: 20px;
`;
